import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import {
  Menu as MenuIcon,
  Person as AccountIcon,
  ArrowBack as ArrowBackIcon
} from "@material-ui/icons";
import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import { Typography } from "../Wrappers/Wrappers";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar
} from "../../context/LayoutContext";
import { useUserDispatch } from "../../context/UserContext";
import Rest from "../../helpers/Rest";
import logo from "../../images/WhiteLogo.png"

export default function Header(props) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const layoutState = useLayoutState(), layoutDispatch = useLayoutDispatch(), userDispatch = useUserDispatch();

  const [profileMenu, setProfileMenu] = useState(null);
  const [isSmall, setSmall] = useState(false);

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  function handleWindowWidthChange() {
    setSmall(window.innerWidth < theme.breakpoints.values.md);
  }

  return (
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <div style={{display:"flex", alignItems:"center"}}>
            <IconButton
                color="inherit"
                onClick={() => toggleSidebar(layoutDispatch)}
                className={classNames(
                  classes.headerMenuButton,
                  classes.headerMenuButtonCollapse
                )}
            >
              <MenuIcon
                  classes={{
                    root: classNames(classes.headerIcon, classes.headerIconCollapse)
                  }}
              />
            </IconButton>
            <img src={logo} height={28} alt="SonaSafe"/>
            <span className={classes.appTitleDivider} />
            <Typography className={classes.appTitle}>Device Management</Typography>
          </div>
        </Toolbar>
      </AppBar>
  );
}
